import banksApi from '@modules/banks/api';
import { useQuery } from '@tanstack/react-query';

const useGetDistinctBankProducts = () => {
  const { isLoading, data, error } = useQuery({
    queryKey: ['distinctBankProducts'],
    queryFn: () => banksApi.getDistinctBankProducts(),
    retry: 2,
    // One hour
    staleTime: 1000 * 60 * 60,
  });

  return {
    data: data?.sort((a, b) => {
      const bankRateA = a.name.toLocaleLowerCase();
      const bankRateB = b.name.toLocaleLowerCase();
      return bankRateA.localeCompare(bankRateB);
    }),
    isLoading,
    error,
  };
};

export { useGetDistinctBankProducts };
